import { Component } from "react";

class Footer extends Component {
    render() {
        return (
            <footer className="ns-footer mt-auto py-1 fixed-bottom">
                <div className="container-fluid text-center">
                    <span>© RFI All rights reserved. Powered by Netsurf</span>
                </div>
            </footer>
        );
    }
}

export default Footer;
